let pathProxy = "";
//Getting entity Id from session storage
if (process.env.NODE_ENV === "development") {
  pathProxy = "https://dev.maffqod.com/api/v1/";
} else {
  pathProxy = "https://dev.maffqod.com/api/v1/";
}


const API_ENDPOINTS = {
    getSettings: pathProxy + `settings`,

    loginRegisterUrl: pathProxy + `user/auth/sign-up`,
    logoutUser: pathProxy + `user/auth/logout`,
    profileUser: pathProxy + `user/auth/get_user`,
    changePassword: pathProxy + `user/auth/change-password`,
    
    getCategory: pathProxy + `categories/list-categories`,
    getSubCategory: pathProxy + `categories/list-sub-categories`,

    getRegions: pathProxy + `utilities/regions`,
    getCities: id => pathProxy + `utilities/regions/${id}/cities`,

    getContent: id => pathProxy + `contents/pages/${id}/content-details`,

    
    getItems: pathProxy + `items`,
    getItemById: id => pathProxy + `items/${id}`,
    getMyItems: pathProxy + `items/my-list`,
    createNewItem : pathProxy + `items`,
}
export default API_ENDPOINTS;